import React from 'react'
import { Wrapper } from './style'
import { ForgotForm } from './Form'
import { Link } from 'react-router-dom'
import SEO from 'src/seo'
const ForgotPasswordPage = () => {
  return (
    <Wrapper>
      <SEO title="Reset" />
      <Link to="/accounts/login" className="option-link">
        <p className="back">Back</p>
      </Link>
      <ForgotForm />
    </Wrapper>
  )
}

export { ForgotPasswordPage }
